import sortBy from 'ramda/src/sortBy'
import prop from 'ramda/src/prop'

/**
 * Returns sort function that sort array by given propName
 */
export default (propName) => sortBy(prop(propName))
